var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.kind && _vm.value.kind && _vm.value.name)?_c('span',[_c('LinkName',{attrs:{"type":_vm.kind,"value":`${_vm.value.kind} ${_vm.value.name}`,"object-id":_vm.value.name,"namespace":_vm.value.namespace,"product":_vm.product,"show-type":true}})],1):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }